import * as S from './SignInTitle.styled';

export interface SignInTitleProps {
  title?: string;
  mb: number;
}

export default function SignInTitle({ title, mb }: SignInTitleProps) {
  return (
    <S.Container mb={mb}>{title && <S.Title>{title}</S.Title>}</S.Container>
  );
}
